var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('md-app',[_c('md-app-toolbar',[_c('Bar')],1),_c('md-app-drawer',{attrs:{"md-permanent":"full"}},[_c('Menu')],1),_c('md-app-content')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }